const TitleSection = ({
  title,
  subTitleAboveTitle,
  showColorTitle,
  showBlackTitle,
  editButton = null,
  buttonBeforeTitle = null,
  buttonAfterTitle = null,
  titleTextColor = null,
  titleFontSize = "20px",
}) => {
  return (
    <div
      className="appbar-title-stack"
      style={{
        position: "absolute",
        width: "100%",
        left: 0,
        right: 0,
        zIndex: 1,
      }}
    >
      {subTitleAboveTitle && (
        <p className="appbar-subtitle" style={{ marginTop: "-30px", paddingBottom: "6px" }}>
          {subTitleAboveTitle}
        </p>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {showColorTitle && !showBlackTitle && (
          <h2
            style={{
              color: "#0D6EFD",
              fontSize: titleFontSize,
              marginTop: "5px",
              margin: 0,
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {buttonBeforeTitle && (
              <span style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
                {buttonBeforeTitle}
              </span>
            )}
            <span>{title}</span>
            {buttonAfterTitle && (
              <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "10px" }}>
                {buttonAfterTitle}
              </span>
            )}
            {editButton && (
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                {editButton}
              </span>
            )}
          </h2>
        )}
        {showBlackTitle && (
          <h2
            style={{
              fontSize: titleFontSize,
              margin: 0,
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              color: titleTextColor || "black",
            }}
          >
            {buttonBeforeTitle && (
              <span style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
                {buttonBeforeTitle}
              </span>
            )}
            <span>{title}</span>
            {buttonAfterTitle && (
              <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "10px" }}>
                {buttonAfterTitle}
              </span>
            )}
            {editButton && (
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                {editButton}
              </span>
            )}
          </h2>
        )}
        {!showColorTitle && !showBlackTitle && (
          <h2
            style={{
              fontSize: titleFontSize,
              margin: 0,
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {buttonBeforeTitle && (
              <span style={{ display: "inline-flex", alignItems: "center", marginRight: "10px" }}>
                {buttonBeforeTitle}
              </span>
            )}
            <span>{title}</span>
            {buttonAfterTitle && (
              <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "10px" }}>
                {buttonAfterTitle}
              </span>
            )}
            {editButton && (
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                {editButton}
              </span>
            )}
          </h2>
        )}
      </div>
    </div>
  );
};

export default TitleSection;
